module.exports = __webpack_public_path__ + "static/media/icon-user.7de5e5f7.svg";